export default "__VITE_ASSET__a$fOox5kOrvoak3$2sVNlg__"